/**
 * TODO I found a bug where all size's id's are 0. I notice it happens in perfume products. So I'm forced to fix that here. Should be fixed on Xapi
 * @param {Sizes} [sizeData]
 */
function fixSizeIdXapiBug(sizeData) {
  if (sizeData) {
    const { sizeMap = {} } = sizeData;

    /** @type {sizeMap} */
    const newSizeMap = {};
    Object.keys(sizeMap).forEach((id) => {
      newSizeMap[id] = { ...sizeMap[id], id: parseInt(id, 10) };
    });

    return {
      ...sizeData,
      sizeMap: newSizeMap,
    };
  }

  return sizeData;
}

/**
 *
 * @param {Sizes} [sizeData]
 * @returns {Size[]}
 */
function orderSizesBySeqNumber(sizeData) {
  const sizeMap = sizeData?.sizeMap || {};
  const sizeIds = sizeData?.orderedSizesBySeqNumber || [];
  // Handle consolidated variant issue where orderedSizesBySeqNumber sent as empty array
  return sizeIds.length > 1 ? sizeIds.map((sizeId) => sizeMap[sizeId]) : Object.values(sizeMap);
}

/**
 *
 * @param {Product | undefined} product
 * @returns {ParsedSizes}
 */
module.exports = function SizeParser(product) {
  const sizes = product?.traits?.sizes;
  const fixedSizeData = fixSizeIdXapiBug(sizes);
  return {
    label: sizes?.displayValue,
    selectedSize: fixedSizeData?.selectedSize ?? -1,
    sizeMap: fixedSizeData?.sizeMap || {},
    sizeArray: orderSizesBySeqNumber(fixedSizeData),
  };
};
